<template>
  <div>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { avatarProps } from './avatar'

defineOptions({
  name: 'VsAvatar',
})

const props = defineProps(avatarProps)

// init here
</script>
